export default __webpack_public_path__ + "static/media/subscription.49143cd3.svg";